/**
 * ヘッダー
 */

jQuery( function ($) {
	let scrollTop = 0;
	$( document ).on( 'scroll', function () {
		const mvHeight = $('.p-mainvisual__image').height();
		scrollTop = $( window ).scrollTop();

		if ( scrollTop > mvHeight ) {
			$( '.home .js-header' ).removeClass( '-transparent' );
		} else {
			$( '.home .js-header' ).addClass( '-transparent' );
		}
	} ); 
} );